export default "__VITE_ASSET__OKI8nXlM__"